import type { BusinessCatalogItem } from '~/api/graphql/generated/types'

export const getInventoryItemDisplayName = (
  inventoryItem:
    | Pick<BusinessCatalogItem, 'name' | 'variation'>
    | null
    | undefined,
): string => {
  if (!inventoryItem) {
    return ''
  }

  return [
    inventoryItem.name?.trim(),
    inventoryItem.variation?.composedName?.trim(),
  ]
    .filter(Boolean)
    .join(' | ')
}

export { getInventoryItemDisplayQuantity } from '~/components/dashboard/admin/catalog/inventory/inventoryUtils'
